import { Modal } from './Modal';
import { Button } from './Button';

interface ConfirmDialogProps {
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback when dialog is closed */
    onClose: () => void;
    /** Callback when user confirms the action */
    onConfirm: () => void;
    /** Dialog title */
    title: string;
    /** Dialog message/description */
    message: string;
    /** Confirm button text (default: "Confirm") */
    confirmText?: string;
    /** Cancel button text (default: "Cancel") */
    cancelText?: string;
    /** Variant for confirm button (default: "danger") */
    variant?: 'primary' | 'danger';
    /** Whether the confirm action is in progress */
    isLoading?: boolean;
}

/**
 * Reusable confirmation dialog component
 * Wraps Modal with confirm/cancel actions
 */
export const ConfirmDialog = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    variant = 'danger',
    isLoading = false,
}: ConfirmDialogProps) => {
    const handleConfirm = () => {
        onConfirm();
    };

    const handleClose = isLoading ? () => {} : onClose;

    return (
        <Modal isOpen={isOpen} onClose={handleClose} title={title}>
            <div className="space-y-4">
                <p className="text-gray-700">{message}</p>

                <div className="flex justify-end gap-3 pt-4">
                    <Button onClick={handleClose} variant="secondary" disabled={isLoading}>
                        {cancelText}
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        variant={variant}
                        disabled={isLoading}
                        aria-busy={isLoading}
                    >
                        {isLoading ? 'Processing...' : confirmText}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

